import React from 'react';
import PropTypes from 'prop-types';
// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BecomeHost.css';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import AddListingModel from '../../mobxStores/AddListingModel';
import AddListingWizard from '../../components_new/addListing/AddListingWizard';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import Bro from 'brototype';
import { getListingData } from '../../components_new/addListing/getListingQL';

const _store = new AddListingModel(getListingData);

@observer
class BecomeHost extends React.Component {
  @observable store = _store;
  static propTypes = {
    title: PropTypes.string.isRequired,
    mode: PropTypes.string,
    listId: PropTypes.number,
    formBaseURI: PropTypes.string,
    mode: PropTypes.string,
  };

  componentDidMount() {
    const { listId, query } = this.props;
    if (listId) {
      this.store.listId = listId;
      this.store.editing = query.editing;
    }
  }

  render() {
    const {
      formPage,
      formBaseURI,
      listId,
      query,
      account,
      listingFields,
    } = this.props;

    if (formPage) {
      this.store.moveToUrl(formPage);
    } else {
      this.store.reInit();
      this.store.moveToUrl('intro');
    }
    //IF listId - Query for listing && update store

    const roomType = Bro(listingFields).iCanHaz('data.roomType') || '';
    const userInfo = account || { firstName: 'you' };

    return (
      <div className={s.root}>
        <div className={s.container}>
          <AddListingWizard
            listId={listId}
            store={this.store}
            account={userInfo}
            categories={roomType}
            formPage={formPage}
            formBaseURI={formBaseURI}
            query={query}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  withStyles(s),
  connect(
    state => ({
      account: state.account.data,
      listingFields: state.listingFields,
    }),
    {},
  ),
)(BecomeHost);



// WEBPACK FOOTER //
// ./src/routes/becomeHost/BecomeHost.js